import React, { useCallback, useEffect, useState } from "react"
import Button from "./Button"

interface Props {
  text: string
  text_to_copy: string
}

const CopyableText = ({ text, text_to_copy }: Props) => {
  const [ markJustCopied, setMarkJustCopied ] = useState(false)

  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(text_to_copy).then(() => setMarkJustCopied(true))
  }, [text_to_copy])

  useEffect(() => { // clear "markJustCopied"
    let timeout: number
    if (markJustCopied) {
      timeout = window.setTimeout(() => {
        setMarkJustCopied(false)
      }, 1500)
    }

    return () => { // cleanup
      if (timeout) { window.clearTimeout(timeout) }
    }
  }, [markJustCopied]);

  return <Button primary onClick={copyToClipboard} iconPos="end" iconBaseName={markJustCopied ? "iconCheck" : "iconSocialLink"}>{text}</Button>
}

export default CopyableText